<template>
    <section class="container">
        <div class="container">
            <div class="column mcdiarmid-logo" style="padding-top: 0 !important; padding-left: 0; margin-left: -0.55rem">
                <img src="static/logo.svg" width="150" alt="Mcdiarmid Flowers Logo">
                <h3 style="margin-left: -0.55rem"> Family Owned &amp; Operated </h3>
            </div>
        </div>


	<div class="container" id="no-christmas-delivery-2022" style="display: none; width: 100%; border: 2px solid red; color: red; font-size: 54px; text-align: center; margin-top: 0.5em; margin-bottom: 1em; font-weight: bold; ">
		We are no longer taking orders from the website. <br />To place an order for delivery before Christmas, <br/>please call us at 204-489-5949.
	</div>

	<div class="container" id="year-end-vacation-2022" style="display: none; width: 100%; border: 2px solid red; color: red; font-size: 54px; text-align: center; margin-top: 0.5em; margin-bottom: 1em; font-weight: bold; ">
		Our shop will be closed for the holidays from December 25 to January 3. <br />
 		Seasons greetings and we look forward to working with you in 2023!
	</div>

<!--
	<div class="container" id="website-maintenance" style="width: 100%; border: 2px solid red; color: red; font-size: 54px; text-align: center; margin-top: 0.5em; margin-bottom: 1em; font-weight: bold; ">
            Apologies but website is currently under maintenance. <br />To place your order <br />please call us at 204-489-5949.
        </div>



	<div class="container" id="no-mothers-online-delivery" style="display: none; width: 100%; border: 2px solid red; color: red; font-size: 54px; text-align: center; margin-top: 0.5em; margin-bottom: 1em; font-weight: bold; ">
	    We are no longer taking online orders for <br />Mother's Day. To place your order <br />please call us at 204-489-5949.
	</div>

	<div class="container" id="no-mothers-online-delivery" style="display: none; width: 100%; border: 2px solid red; color: red; font-size: 54px; text-align: center; margin-top: 0.5em; margin-bottom: 1em; font-weight: bold; ">
	    We are no longer taking online orders for <br />Mother's Day weekend. To place your order <br />please call us at 204-489-5949.
	</div>

	<div class="container" id="year-end-vacation" style="display: none; width: 100%; border: 2px solid red; color: red; font-size: 54px; text-align: center; margin-top: 0.5em; margin-bottom: 1em; font-weight: bold; ">
            McDiarmid Flowers will be closed from December 25th and re-open on January 3rd. <br />
            Wishing you Happy Holidays and looking forward to filling your floral needs in 2022!
        </div>

	<div class="container" id="no-valentines-online-delivery" style="display: none; width: 100%; border: 2px solid red; color: red; font-size: 54px; text-align: center; margin-top: 0.5em; margin-bottom: 1em; font-weight: bold; ">
		We are no longer taking website orders for <br/>Valentines Day. Please call the shop directly <br />at 204-489-5949 to place your order.
	</div>

-->


        <div class="columns main-categories">
            <div class="column category-card">
                <router-link to="/holiday">
                    <div class="image text-container holiday">
                        <h2 class="h2-main">Holiday</h2>
                    </div>
                </router-link>
            </div>
            <div class="column category-card">
                <router-link to="/weddings-&-events">
                    <div class="image text-container weddingsevents">
                        <h2 class="h2-main">Weddings <br> &amp; Events</h2>
                    </div>
                </router-link>
            </div>
            <div class="column category-card">
                <router-link to="/everyday">
                    <div class="image text-container everyday">
                        <h2 class="h2-main">Everyday</h2>
                    </div>
                </router-link>
            </div>

        </div>

        <div class="container">
            <div class="column instagram-feed">
                <div class="full-width-deco">
                    <h3> Follow us on Instagram! </h3>
                </div>
                <div class="tile is-ancestor">
                    <div class="tile is-12 is-parent">
                        <div class="tile is-child">
                            <instagram-display></instagram-display>
                        </div>
                    </div>
                </div>
                <div class="full-width-deco">
                    <h3> @mcDiarmidFlowers </h3>
                </div>
            </div>
        </div>


    </section>


</template>

<script>
import InstagramDisplay from './InstagramDisplay';

export default {
  components: { InstagramDisplay },
  name: 'Index',
};


            function loadMe() {
                let dateNow = new Date();
                let thisYear = dateNow.getFullYear();

                let timeNow = dateNow.getTime();

/*
                let may5 = new Date(thisYear, 4, 5).getTime();
                let may9 = new Date(thisYear, 4, 9).getTime();

                if ((timeNow >= may5) && (timeNow <= may9)) {
			if (document.getElementById('no-mothers-online-delivery')) {
				document.getElementById('no-mothers-online-delivery').style.display = 'block';
			}
                }

                let dec24 = new Date(thisYear, 11, 24).getTime();
                let jan2 = new Date(thisYear, 0, 2).getTime();

                if ((timeNow >= dec24) || (timeNow <= jan2)) {
                        if (document.getElementById('year-end-vacation')) {
                                document.getElementById('year-end-vacation').style.display = 'block';
                        }
                }

                let feb134pm = new Date(thisYear, 1, 13, 16).getTime();
                let feb146pm = new Date(thisYear, 1, 14, 18).getTime();

                if ((timeNow >= feb134pm) && (timeNow <= feb146pm)) {
                        if (document.getElementById('no-valentines-online-delivery')) {
                                document.getElementById('no-valentines-online-delivery').style.display = 'block';
                        }
                }


		// 2022 mothers day
		let may66pm = new Date(thisYear, 4, 6, 18).getTime();
		let may76pm = new Date(thisYear, 4, 7, 18).getTime();

                if ((timeNow >= may66pm) && (timeNow <= may76pm)) {
                        if (document.getElementById('no-mothers-online-delivery')) {
                                document.getElementById('no-mothers-online-delivery').style.display = 'block';
                        }
                }
*/


                let dec22 = new Date(thisYear, 11, 22).getTime();
                let dec25 = new Date(thisYear, 11, 25).getTime();
                if ((timeNow >= dec22) && (timeNow < dec25)) {
                        if (document.getElementById('no-christmas-delivery-2022')) {
                                document.getElementById('no-christmas-delivery-2022').style.display = 'block';
                        }
                }


                let dec24 = new Date(thisYear, 11, 24).getTime();
                let jan3 = new Date(thisYear, 0, 3).getTime();

                if ((timeNow >= dec24) || (timeNow < jan3)) {
                        if (document.getElementById('year-end-vacation-2022')) {
                                document.getElementById('year-end-vacation-2022').style.display = 'block';
                        }
                }


            }

window.addEventListener("load", loadMe);

</script>





// WEBPACK FOOTER //
// src/components/Index.vue